import React from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  right?: React.ReactNode;
  below?: React.ReactNode;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  right,
  below,
  className,
}) => {
  return (
    <div className={className ? className : ''}>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-medium text-gray-900 font-nav">
            {title}
          </h1>
          {description && (
            <p className="mt-2 text-sm text-gray-600">{description}</p>
          )}
        </div>
        {right}
      </div>
      {below && <div className="mt-4">{below}</div>}
    </div>
  );
};

export default PageHeader;
